import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import { Card, CardText } from 'material-ui/Card';
import { List } from 'material-ui/List';

import AmenityBookingTodo from './todos/AmenityBookingTodo';

const style = {
  card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    transition: 'all .2s linear',
  },
  card_text: {
    padding: '8px',
    color: '#6F6F6F',
    fontFamily: '"Circular", sans-serif !important',
  },
};

export default connect(store => {
  return {
    todoData: store.todo.todoData,
  };
})(
  localize()(
    class AmenityBookingComponent extends Component {
      constructor(props, context) {
        super(props, context);
        this.state = {
          isExpanded: false,
        };
      }

      render() {
        const toDoData = this.props.todoData
          ? this.props.todoData.filter(toDo => toDo.event_type === 'AmenityBooking')
          : [];

        const amenityBookings = toDoData.map((toDo, index) => {
          return <AmenityBookingTodo key={index} showingData={toDo} />;
        });

        if (toDoData.length === 0) return null;

        return (
          <div className="grid-column" ref="toDoContainer">
            <h3 style={{ marginTop: 0 }}>{this.props.translate('portalAmenities.myBookings')}</h3>
            <Card style={style.card} className="card">
              <div ref="innerToDOContainer">
                <CardText expandable={true} style={style.card_text}>
                  <List style={{ padding: 0 }}>{amenityBookings}</List>
                </CardText>
              </div>
            </Card>
          </div>
        );
      }
    }
  )
);
